export default {
  computed: {
    classObject () {
      return {
        'form-input--inline': this.inline,
        'form-input--inline-label': this.inlineLabel,
        'form-input--white': this.color === 'white',
        'form-input--neutral': this.color === 'neutral',
        'form-input--primary': this.color === 'primary',
        'form-input--secondary': this.color === 'secondary',
        'is-disabled': this.disabled,
        'has-error': this.error
      }
    },
    formID () {
      if (typeof this.id === 'undefined') {
        return 'form-field-' + this._uid
      } else {
        return this.id
      }
    }
  }
}
